"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepCardTitle = void 0;

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../../..");

var _mobxReact = require("mobx-react");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("../StepCard.css");

var _styles = {
  "card": "StepCard__card___LI0aC",
  "title": "StepCard__title___3IZi8",
  "date": "StepCard__date___1q_HB",
  "chip-tag": "StepCard__chip-tag___393Mz",
  "step": "StepCard__step___1MmRI",
  "active": "StepCard__active___2Jj5i",
  "step-title": "StepCard__step-title___1qMha",
  "show-steps": "StepCard__show-steps___3lBjm",
  "show-hide-steps": "StepCard__show-hide-steps___2ThPx"
};

const styles = _bind.default.bind(_styles);

const StepCardTitle = (0, _mobxReact.observer)(({
  className,
  title,
  date,
  chipTitles,
  dataTestId
}) => {
  const composed_classname = (0, _bind.default)(styles('title', className));
  return _react.default.createElement("div", {
    className: composed_classname,
    "data-testid": dataTestId
  }, _react.default.createElement(_.Flex, {
    justifyContent: 'space-between',
    gap: 8
  }, _react.default.createElement(_.Text, {
    text: title,
    variant: 'medium',
    size: 18
  }), date && _react.default.createElement("div", {
    className: styles('date')
  }, _react.default.createElement(_.Text, {
    text: date,
    variant: 'medium',
    size: 13
  }))), chipTitles.length > 0 && _react.default.createElement(_.Flex, {
    justifyContent: 'flex-start',
    gap: 8
  }, chipTitles.map((state, i) => _react.default.createElement("div", {
    className: styles('chip-tag'),
    key: `${state}-${i}`
  }, _react.default.createElement(_.Text, {
    text: state,
    variant: 'medium',
    size: 13
  })))));
});
exports.StepCardTitle = StepCardTitle;